import { Overlay } from 'containers/ActionsOverlayContainer/ActionsOverlayContainer';
import { inject, observer } from 'mobx-react';
import { ActionsStoreType } from 'models/ActionsStore';
import { ApplicationStoreType } from 'models/ApplicationStore';
import { DataStoreType } from 'models/DataStore';
import { PainpointsStoreType } from 'models/PainpointsStore';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { ROUTE_FIRE } from 'utils/constants/routes';
import ActionOverlayButton from './ActionOverlayButton';

function BenchmarksButton({
  dataStore,
  actionsStore,
  applicationStore,
  painpointsStore,
  handleOverlayOpen
}: {
  dataStore?: DataStoreType;
  actionsStore?: ActionsStoreType;
  painpointsStore?: PainpointsStoreType;
  applicationStore?: ApplicationStoreType;
  handleOverlayOpen: (overlay: string) => void;
}) {
  const intl = useIntl();
  const location = useLocation();
  const isFireContext = location.pathname.includes(ROUTE_FIRE);
  const fireId = isFireContext ? dataStore?.fire?.id : undefined;
  let disabled = false;
  let intlId: string;
  let count: number;

  const organizationId = dataStore!.currentOrganizationId!;
  const projectId = dataStore!.currentProjectId!;
  const painpointIds = actionsStore!.selectedIds.Painpoint;

  if (
    painpointIds.length <
    dataStore!.currentProject?.aiSelectLimits.minPainpoints!
  ) {
    disabled = true;
    count = dataStore!.currentProject?.aiSelectLimits.minPainpoints!;
    intlId = 'search benchmarks not enough painpoints';
  } else if (
    painpointIds.length >
    dataStore!.currentProject?.aiSelectLimits.maxPainpoints!
  ) {
    disabled = true;
    count = dataStore!.currentProject?.aiSelectLimits.maxPainpoints!;
    intlId = 'search benchmarks too many painpoints';
  }

  return (
    <ActionOverlayButton
      label={intl.formatMessage({ id: 'Search benchmarks' })}
      iconName="ai"
      disabled={dataStore?.project?.reachedBenchmarkLimit}
      onClick={async () => {
        if (disabled) {
          applicationStore!.setFlashMessage(
            intl.formatMessage(
              {
                id: intlId
              },
              { count }
            ),
            'inlineError'
          );
          return;
        } else if (!isFireContext && !dataStore?.project?.has_user_settings) {
          handleOverlayOpen(Overlay.settings);
          return;
        }

        if (!isFireContext && !dataStore?.project?.briefing.completed) {
          applicationStore!.setAiUnavailable(true);
          return;
        }

        try {
          const response = await painpointsStore!.findBenchmarksByAi(
            organizationId,
            projectId,
            painpointIds,
            fireId
          );
          if (!response.success) {
            applicationStore!.setFlashMessage(
              intl.formatMessage({ id: 'AI create error' }),
              'error'
            );
          }
        } catch (error: any) {
          applicationStore!.setFlashMessage(
            intl.formatMessage({
              id: 'benchmark search failed error'
            }),
            'error'
          );
        }
      }}
    />
  );
}

export default inject(
  'dataStore',
  'actionsStore',
  'painpointsStore',
  'applicationStore'
)(observer(BenchmarksButton));
